import 'react-datepicker/dist/react-datepicker.css'
import '../styles/FundProfileApp.scss'
import React, {useEffect} from 'react'
import i18next from 'i18next'
import SVGSpriteSheet from '../common/SVGSpriteSheet'
import {FundProfileContextProvider} from './ctx/providers/FundProfileContextProvider'
import Layout from './Layout'
import {ILanguage} from '../types/common'

const FundProfileApp: React.FC<{
    customconfiguration: Record<string, never>
    contextconfiguration?: Record<string, never>
    i18n?: Record<string, string>
}> = ({contextconfiguration, customconfiguration, i18n}) => {
    const language: ILanguage = customconfiguration.lang
    const fund: string = customconfiguration.fund

    useEffect(() => {
        i18next.changeLanguage(customconfiguration.lang)
    }, [contextconfiguration, customconfiguration, i18n])

    return (
        <div className="app-allianz">
            <FundProfileContextProvider>
                <SVGSpriteSheet />
                <Layout language={language} fund={fund} />
            </FundProfileContextProvider>
        </div>
    )
}

export default FundProfileApp
